import React from 'react';
import { Alert } from 'antd';

interface WarningMessageProps {
  message: string;
  style?: React.CSSProperties;
}

const WarningMessage = ({ message, style }: WarningMessageProps) => (
  <Alert
    message={message}
    type="warning"
    showIcon
    style={{ marginBottom: 16, ...style }}
  />
);

export default WarningMessage;
